export enum Systems {
  old = 'StemScopes3_5',
  new = 'StemScopes4_0',
  math = 'MathNation4_0',
}
